import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "line" }
const _hoisted_2 = {
  key: 0,
  class: "gloss"
}
const _hoisted_3 = {
  key: 0,
  class: "line counterpart"
}
const _hoisted_4 = { class: "arrow" }
const _hoisted_5 = {
  key: 0,
  class: "unconfirmed"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hover && _ctx.hover.word.lexeme)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "hover-card",
        style: _normalizeStyle({ left: `${_ctx.hover.x}px`, top: `${_ctx.hover.y + 6}px` })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.fontOf(_ctx.hover.word.lexeme))
          }, _toDisplayString(_ctx.hover.word.lexeme.headword), 3),
          (_ctx.hover.word.lexeme.gloss)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.hover.word.lexeme.gloss), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.hover.word.counterpart.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.isRendered(_ctx.hover.word.lexeme.language) ? '←' : '→'), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hover.word.counterpart, (c) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: c.key,
                  class: _normalizeClass(_ctx.fontOf(c))
                }, _toDisplayString(c.headword), 3))
              }), 128)),
              (!_ctx.hover.word.confident)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "unconfirmed"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "hint" }, "click for the index", -1))
      ], 4))
    : _createCommentVNode("", true)
}